export default {
  inject: ['parentValidator'],
  created() {
    this.$validator = this.parentValidator;
  },
};
